import React, { useState, useEffect } from 'react';
import { TextField, Button, Box, Card, CardContent, Stack, Autocomplete, Grid } from '@mui/material';
import { MenuItem, FormControl, InputLabel, Select } from '@mui/material';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { BASE_URL } from '../../App';
import Swal from 'sweetalert2';
import axios from 'axios';

const Product_Registration_Report = () => {
    const [dateFrom, setDateFrom] = useState(null);
    const [dateTo, setDateTo] = useState(null);
    const [groupcode1, setgroupcode] = useState(null);
    const [branch, setBranch] = useState();
    const [dealer, setDealer] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [tableData, setTableData] = useState([]);
    const [showTable, setShowTable] = useState(false);
    const [showDownloadButton, setShowDownloadButton] = useState(false);
    const [branchData, setBranchData] = useState([]);
    const [dealerData, setDealerData] = useState([]);
//BRANCH_CODE
const login_id = localStorage.getItem("LOGIN_ID");
const BRANCH_CODE = localStorage.getItem("BRANCH_CODE");
const groupcode=localStorage.getItem("GROUP_CODE");
const dealername=localStorage.getItem("USER_NAME");
const dealercode=localStorage.getItem("USER_ID");
    useEffect(() => {
        const fetchBranchData = async () => {
            setLoading(true);
            try {
                const response = await axios.post(BASE_URL + '/getbranchdetailsforproduct', {
                    login_id: login_id,
                    branch_code: BRANCH_CODE,
                    groupcode:groupcode,
                });

                if (response.data && response.data.branchlist) {
                   // setBranchData(response.data.branchlist);
                  let updatedBranchData=response.data.branchlist;

                  setgroupcode(response.data.groupcode);
                  
               
                   setBranchData(updatedBranchData);
                 
                } else {
                    setError('No branches found.');
                }
            } catch (error) {
                setError('Failed to fetch branches.');
            } finally {
                setLoading(false);
            }
        };

        fetchBranchData();
    }, []);

    const fetchDealerData = async (selectedBranch) => {
        if (!selectedBranch) return;

        try {
           // alert('4');
            const response = await axios.post(BASE_URL + '/getdealerdetailsreport', {
                branch: selectedBranch,
                dealer_condition: selectedBranch,
            });

            if (response.data && response.data.dealerList) {
             

                let updateddealer=response.data.dealerList;

                
                
                 if (groupcode1 === '1' || groupcode1 === '2') {
                  
                //   updateddealer = [
                //          { "dealer_code": "ALL", "dealername": "ALL" },
                //          ...updateddealer
                //      ];
                 }
                 setDealerData(updateddealer);
            } else {
                setDealerData([]);
                setError('No dealers found for this branch.');
            }
        } catch (error) {
            setError('Failed to fetch dealers.');
        }
    };

    // useEffect(() => {
    //     if (branch) {
    //         fetchDealerData(branch);
    //     }
    // }, [branch]);


    const formatDate = (date) => {
        if (!date) return '';
        const d = new Date(date);
        const day = d.getDate().toString().padStart(2, '0');
        const month = (d.getMonth() + 1).toString().padStart(2, '0');
        const year = d.getFullYear();
        return `${day}-${month}-${year}`;
    };


    const handleDateChange = (setter) => (event) => {
        const date = event.target.value;
        setter(date);
    };

    const handleViewData = async () => {
        console.log('Date From:', dateFrom);
        console.log('Date To:', dateTo);
        console.log('Branch:', branch);
        console.log('Dealer:', dealer);


        setLoading(true);
        setError(null);
        

        Swal.fire({
            title: 'Loading...',
            text: 'Fetching data...',
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            },
        });

        try {
            const requestData = {
                login_id: login_id,
                branch_code: branch,
                dealer_code: dealer,
                from_date: dateFrom ? dateFrom : '',
                to_date: dateTo ? dateTo : '',
            };

            console.log('Request Data:', requestData);

            const response = await axios.post(BASE_URL + '/getproductregistrationreport', requestData, {
                headers: {
                    'Content-Type': 'application/json'
                }
            });

            console.log('Response Data:', response.data);

            if (response.status === 200) {
                if (response.data && response.data.data) {
                    setTableData(response.data.data);
                    setShowTable(true);
                    setShowDownloadButton(true);
                } else {
                    setTableData([]);
                    setError('No data found for the selected criteria.');
                }
            } else {
                setError('Unexpected response from the server.');
                console.error('Error Response:', response);
                Swal.fire('Error', `Unexpected response: ${response.statusText}`, 'error');
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            setError('Failed to fetch data.');
            Swal.fire('Error', 'An error occurred while fetching data.', 'error');
        } finally {
            setLoading(false);
            Swal.close();
        }
    };

    const handleDownloadExcel = () => {
 
             if (tableData.length === 0) {
        Swal.fire({
            icon: "info",
            text: 'No Data Available For export!'
        });
        return;
    } 
         Swal.fire({
             title: 'Are you sure?',
             text: 'You are about to download the Excel file. Do you want to continue?',
             icon: 'warning',
             showCancelButton: true,
             confirmButtonText: 'Yes, Download',
             cancelButtonText: 'No, Cancel',
         }).then((result) => {
       if (result.isConfirmed) {

        const ExcelJS = require('exceljs');
              const workbook = new ExcelJS.Workbook();
              const worksheet = workbook.addWorksheet('Sheet1');
  
             
              worksheet.columns = Object.keys(tableData[0]).map(key => ({ header: key, key }));
  
             
              tableData.forEach(data => worksheet.addRow(data));
  
             
              const headerRow = worksheet.getRow(1);
              headerRow.eachCell((cell) => {
                cell.fill = {
                  type: 'pattern',
                  pattern: 'solid',
                  fgColor: { argb: 'bf43bb' }
                };
                cell.font = {
                  bold: true,             
                  color: { argb: 'FFFFFF' }
                };
              });
             
              worksheet.autoFilter = {
                  from: 'A1',
                  to: 'I1'
              };
             // setOpen(false);
             
              setTimeout(() => {
                  workbook.xlsx.writeBuffer().then((buffer) => {
                      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                      const link = document.createElement('a');
                      link.href = window.URL.createObjectURL(blob);
                      link.download = 'Product_Registration_Report.xlsx';
                    //  link.download = 'Solar_Customer_Error_Description.xlsx';
                      link.click();
                     
                  });
              }, 1000);
            //     const ws = XLSX.utils.json_to_sheet(tableData);
            //      const wb = XLSX.utils.book_new();
            //      XLSX.utils.book_append_sheet(wb, ws, 'Approved BRV Details');
            //      const excelFile = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });

            //      saveAs(new Blob([excelFile]), 'approved_brv_details.xlsx');
            //    Swal.fire('Downloading...', 'Your file is being downloaded.', 'success');
             }
        });
     };
     const handleBranchChange = (event, value) => {
        // alert('hi');
        // alert('hhh',groupcode1);
        const data = value.BRANCH_CODE;
        setBranch(value.BRANCH_CODE);
	//	alert(data);
        if(groupcode1==='1'||groupcode1==='2')
        {
            // alert('2');
            // alert(groupcode1);
        fetchDealerData(data);
        }
        if (groupcode1 === '3') {
          //  alert('inside');
            setDealerData((prevDealerData) => [
                ...prevDealerData,
                { dealer_code: dealercode, dealername: dealername }
            ]);
        }
    };

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                minHeight: '100vh',
                backgroundColor: '#f4f4f4',
                paddingTop: 3,
                paddingLeft: 3,
            }}
        >
            <Card sx={{ width: '100%', maxWidth: '1800px' }}>
                <CardContent>
                    <Box sx={{ width: '100%' }}>
                        <Grid container spacing={3}>
                      
                            <Grid item xs={6} md={3}>
                                <Autocomplete
                                    disablePortal
                                    options={branchData}
                                    getOptionLabel={(option) =>
                                        `${option.BRANCH_CODE} - ${option.BRANCH_NAME}`
                                    }
                                    renderInput={(params) => <TextField {...params} label="Branch" />}
                                   onChange={handleBranchChange}
                                   //onChange={(event, value) => handleBranchChange( value.BRANCH_CODE)}
                                   sx={{ width: '100%' }}
                                />
{/* 
<FormControl fullWidth>
      <InputLabel>Branch</InputLabel>
      <Select
        value={branch} // Bind the selected branch to the value prop
        onChange={handleBranchChange} // Update the branch state on change
        label="Branch"
        sx={{ width: '100%' }}
      >
        {branchData.map((option) => (
          <MenuItem key={option.BRANCH_CODE} value={option.BRANCH_CODE}>
            {`${option.BRANCH_CODE} - ${option.BRANCH_NAME}`}
          </MenuItem>
        ))}
      </Select>
    </FormControl> */}
                            
                            </Grid>

                            <Grid item xs={6} md={3}>
                                <Autocomplete
                                    disablePortal
                                    options={dealerData}
                                    getOptionLabel={(option) =>
                                       `${option.dealer_code} - ${option.dealername}`
                                    }
                                    renderInput={(params) => <TextField {...params} label="Dealer" />}
                                    onChange={(event, value) => setDealer( value.dealer_code)}
                                    sx={{ width: '100%' }}
                                />
                            </Grid>

                            <Grid item xs={6} md={3}>
                                <TextField
                                    label="From Date"
                                    type="date"
                                    value={dateFrom || ''}
                                    onChange={handleDateChange(setDateFrom)}
                                    InputLabelProps={{ shrink: true }}
                                    fullWidth
                                    sx={{ width: '100%' }}
                                />
                            </Grid>

                            <Grid item xs={6} md={3}>
                                <TextField
                                    label="Date To"
                                    type="date"
                                    value={dateTo || ''}
                                    onChange={handleDateChange(setDateTo)}
                                    InputLabelProps={{ shrink: true }}
                                    fullWidth
                                    sx={{ width: '100%' }}
                                />
                            </Grid>

                            {/* Second Row: Buttons */}
                            <Grid item xs={6} md={3}>
                                <Stack direction="row" spacing={2}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={handleViewData}
                                        disabled={loading || !dateFrom || !dateTo || branch === '' || dealer === ''}
                                        sx={{ width: '100%' }}
                                    >
                                        {loading ? 'Loading...' : 'View'}
                                    </Button>
                                </Stack>
                            </Grid>

                            {showDownloadButton && (
                                <Grid item xs={6} md={3}>
                                    <Stack direction="row" spacing={2}>
                                        <Button
                                            variant="contained"
                                            onClick={handleDownloadExcel}
                                            sx={{
                                                width: '100%',
                                                backgroundColor: 'green',
                                                color: 'white',
                                                '&:hover': {
                                                    backgroundColor: 'darkgreen',
                                                },
                                            }}
                                        >
                                            Download Excel
                                        </Button>
                                    </Stack>
                                </Grid>
                            )}
                        </Grid>

                    </Box>
                </CardContent>
            </Card>

            {error && (
                <Box sx={{ mt: 2, color: 'red' }}>
                    <p>{error}</p>
                </Box>
            )}

            {showTable && !loading && (
                <Box sx={{ mt: 3, width: '100%', maxWidth: '1400px' }}>
                    <div style={{ overflowX: 'auto', maxHeight: '600px', overflowY: 'auto' }}>
                        <table
                            border="1"
                            cellPadding="8"
                            cellSpacing="0"
                            style={{
                                width: '100%',
                                borderCollapse: 'collapse',
                                tableLayout: 'auto',
                            }}
                        >
                            <thead style={{ position: 'sticky', top: 0, backgroundColor: '#1976d2', color: 'white', zIndex: 1 }}>
                                <tr>
                                <th style={{ width: '12%', padding: '8px' }}>SERIAL NO</th>
		   <th style={{ width: '12%', padding: '8px' }}>CUSTOMER_NAME</th>
		   <th style={{ width: '12%', padding: '8px' }}>PLACE</th>
		   <th style={{ width: '12%', padding: '8px' }}>BRANCH_CODE</th>
		   <th style={{ width: '12%', padding: '8px' }}>DEALER_CODE</th>
		   <th style={{ width: '12%', padding: '8px' }}>DEALER_NAME</th>
		   <th style={{ width: '12%', padding: '8px' }}>DEALER_CATEGORY</th>
		   <th style={{ width: '12%', padding: '8px' }}>ITEM CODE</th>
		   <th style={{ width: '12%', padding: '8px' }}>ITEMDESCRIPTION</th>
           <th style={{ width: '12%', padding: '8px' }}>PINCODE</th>
		   <th style={{ width: '12%', padding: '8px' }}>CONTACT_NO</th>
		   <th style={{ width: '12%', padding: '8px' }}>MOBILE_NO</th>
		   
		   <th style={{ width: '12%', padding: '8px' }}>INVOICENO</th>
		   <th style={{ width: '12%', padding: '8px' }}>INVOICE_DATE</th>
		   <th style={{ width: '12%', padding: '8px' }}>WARRANTY_REG_DATE</th>
		   <th style={{ width: '12%', padding: '8px' }}>CREATEDBY</th>
		   <th style={{ width: '12%', padding: '8px' }}>CREATEDON</th>
		   <th style={{ width: '12%', padding: '8px' }}>SOURCE</th>
                                </tr>
                            </thead>
                            <tbody>
                                {tableData.length > 0 ? (
                                    tableData.map((row, index) => (
                                        <tr key={index}>
                                            <td style={{ textAlign: 'center' }}>{row.SERIAL_NO}</td>
                                            <td style={{ textAlign: 'center' }}>{row.CUSTOMER_NAME}</td>
 <td style={{ textAlign: 'center' }}>{row.PLACE}</td>
 <td style={{ textAlign: 'center' }}>{row.BRANCH_CODE}</td>
 <td style={{ textAlign: 'center' }}>{row.DEALER_CODE}</td>
 <td style={{ textAlign: 'center' }}>{row.DEALER_NAME}</td>
 <td style={{ textAlign: 'center' }}>{row.DEALER_CATEGORY}</td>
 <td style={{ textAlign: 'center' }}>{row.ITEM_CODE}</td>
 <td style={{ textAlign: 'center' }}>{row.ITEMDESCRIPTION}</td>
 <td style={{ textAlign: 'center' }}>{row.PINCODE}</td>
 <td style={{ textAlign: 'center' }}>{row.CONTACT_NO}</td>
 <td style={{ textAlign: 'center' }}>{row.MOBILE_NO}</td>
 <td style={{ textAlign: 'center' }}>{row.INVOICENO}</td>
 <td style={{ textAlign: 'center' }}>{row.INVOICE_DATE}</td>
 <td style={{ textAlign: 'center' }}>{row.WARRANTY_REG_DATE}</td>
 <td style={{ textAlign: 'center' }}>{row.CREATEDBY}</td>
 <td style={{ textAlign: 'center' }}>
  {new Date(row.CREATEDON).toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
  }).toUpperCase()}
</td>

 <td style={{ textAlign: 'center' }}>{row.SOURCE}</td>
                                            
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="8">No data available</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </Box>
            )}
        </Box>
    );
};

export default Product_Registration_Report;



























